import { Checkbox, CheckboxProps } from 'antd';
import { ContainerCheckBox } from './styles';

interface ICheckBoxProps extends CheckboxProps {
  children?: React.ReactNode | string;
}

export const ACheckBox: React.FC<ICheckBoxProps> = ({ children, ...res }) => {
  return (
    <ContainerCheckBox>
      <Checkbox {...res}>{children}</Checkbox>
    </ContainerCheckBox>
  );
};
